/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Stat } from './Stat';

class CertExamAuditStat extends Stat {
    constructor() {
        super();
        this.baseUrl += '/certExamAuditStat';
    }

    findCertExamAuditStatList({
        certCatId,
        certExamType,
        statTime,
        orderByKey,
        orderByType,
        currentPage,
        pageSize,
    } = {}) {
        let statTimeBegin = null;
        let statTimeEnd = null;
        if (statTime != null && statTime.length === 2) {
            [statTimeBegin, statTimeEnd] = statTime;
        }
        return super.get('/findCertExamAuditStatList', {
            certCatId,
            certExamType,
            statTimeBegin,
            statTimeEnd,
            orderByKey,
            orderByType,
            currentPage,
            pageSize,
        });
    }
}

export default new CertExamAuditStat();
export { CertExamAuditStat };
